@if (currentMeet$ | async; as currentMeet) {
  @if ({ value: desktop$ | async }; as isDesktop) {
    <div class="p-3">
      @if (currentMeet.logo && isDesktop.value) {
        <div class="meet-logo mb-3">
          <img class="meet-logo--img" src="https://alivestatic.athletic.net/meet-images/{{ currentMeet.logo }}" />
        </div>
      }

      <app-timezone-toggle></app-timezone-toggle>
      <app-locale-toggle></app-locale-toggle>

      @if (
        currentMeet.videoLink ||
        (currentMeet.meetLinks && currentMeet.meetLinks.length > 0) ||
        (currentMeet.athleticNetId && currentMeet.athleticNetId > 0)
      ) {
        <div class="list-group mb-3">
          @if (currentMeet.videoLink) {
            <a href="{{ currentMeet.videoLink }}" target="_blank" class="list-group-item list-group-item-action">
              <fa-icon class="me-2" [icon]="environment.icons.video" [fixedWidth]="true"></fa-icon>
              <span i18n="Watch Live Title on the home sidebar@@homeSidebar.watchLive">Watch Live</span>
            </a>
          }
          @if (currentMeet.athleticNetId > 0) {
            <a
              href="{{ currentMeet.athleticNetMeets[0].url }}"
              target="_blank"
              class="list-group-item list-group-item-action"
            >
              <img
                src="https://s3.amazonaws.com/media.athletic.net/athletic-logos/square/logo-gradient.svg"
                width="20"
                class="me-2"
              />
              <ng-container i18n="Link that takes them to the meet page on AthleticNET@@homeSidebar.viewOnAthleticNet">
                View on AthleticNET
              </ng-container>
            </a>
          }
          @for (meetLink of currentMeet.meetLinks; track meetLink) {
            <a href="{{ meetLink.url }}" target="_blank" class="list-group-item list-group-item-action">
              <fa-icon class="me-2" [icon]="['fas', 'chevron-right']" [fixedWidth]="true"></fa-icon>
              {{ meetLink.name }}
            </a>
          }
        </div>
      }
      @if (
        currentMeet.athleticNetId === -1 && currentMeet.athleticNetMeets && currentMeet.athleticNetMeets.length > 0
      ) {
        <div ngbAccordion [destroyOnHide]="false" class="mb-3">
          <div ngbAccordionItem="multipleAnetAccordion" #multipleAnetAccordion="ngbAccordionItem">
            <h2 ngbAccordionHeader>
              <button ngbAccordionButton class="justify-content-between">
                <span>
                  <img
                    src="https://s3.amazonaws.com/media.athletic.net/athletic-logos/square/logo-gradient.svg"
                    width="20"
                    class="me-2"
                  />
                  <ng-container
                    i18n="
                      Link that takes them to the meet page on AthleticNET when there are multiple
                      meets@@homeSidebar.viewOnAthleticNetMultiple"
                  >
                    View on AthleticNET
                  </ng-container>
                </span>
                <fa-icon
                  [icon]="multipleAnetAccordion.collapsed ? ['far', 'chevron-down'] : ['far', 'chevron-up']"
                ></fa-icon>
              </button>
            </h2>
            <div ngbAccordionCollapse>
              <div ngbAccordionBody class="p-0">
                <ng-template>
                  <div class="list-group list-group-flush">
                    @for (anetMeet of currentMeet.athleticNetMeets; track anetMeet) {
                      <a href="{{ anetMeet.url }}" target="_blank" class="list-group-item list-group-item-action">
                        <fa-icon class="me-2" [icon]="['fas', 'chevron-right']" [fixedWidth]="true"></fa-icon>
                        {{ anetMeet.name }}
                      </a>
                    }
                  </div>
                </ng-template>
              </div>
            </div>
          </div>
        </div>
      }
      @if (isDesktop.value && (currentMeet.athleticNetId || currentMeet.athleticNetMeets)) {
        <h5>
          <fa-icon [icon]="environment.icons.followOn" [fixedWidth]="true" class="me-2"></fa-icon>
          <span i18n="Header over the athletes, teams, and events they follow@@homeSidebar.myFollows">My Follows</span>
        </h5>
        <div class="pb-3">
          <app-follow-list></app-follow-list>
        </div>
      }
      <h5>
        <fa-icon [icon]="environment.icons.location" [fixedWidth]="true" class="me-2"></fa-icon>
        <span i18n="Header over the address of the meet@@homeSidebar.location">Location</span>
      </h5>
      <p>
        {{ currentMeet.location }} (<a
          target="_blank"
          href="https://www.google.com/maps?saddr=Current+Location&daddr={{ currentMeet.location }}"
          i18n="Link to get directions on Google Maps@@homeSidebar.getDirections"
          >Get Directions</a
        >)
      </p>
    </div>
  }
}
